export const ERROR_CODE_500 = 500
export const ERROR_CODE_404 = 404
